// "View as Sam" on a person's page (AdminPerson.dc.html). It starts a view as (hub.start_view_as,
// audited), reads whoami again and opens the Library as them, with the bar on every page until Stop
// viewing. Drawn only for someone the caller may view as: an owner or admin, and only an owner for a
// member of staff. The person: { id, full_name, first_name, role, anonymised_at }. For someone whose first name is
// the database's "there" (a name that gave none), the button names them by their full name, else "View as member"
// (lib/names.js viewAsLabel).
//
// to and back (the critique's admin 15): where the view as opens, in place of the Library (Masterminds opens the
// member's mastermind home, or their log from the log tab), and the admin address Stop viewing returns to, in place of
// their person page (lib/viewAs.jsx takes only an admin address). kind 'menu' draws it as an item of a More menu,
// with the menu's own item class. beforeStart: waited for before the view as starts, and false stops it (Masterminds
// sends a month's close still held first, since nothing can be changed while viewing as).
import { useViewAs } from '../../lib/viewAs.jsx'
import { Icon } from '../shell/Icons.jsx'
import { viewAsLabel } from '../../lib/names.js'

export function ViewAsButton({ person, label, size = 'md', to, back, kind = 'button', itemClass = '', beforeStart }) {
  const viewAs = useViewAs()
  if (!viewAs.canViewAs(person)) return null
  const go = async () => {
    if (beforeStart && (await beforeStart()) === false) return
    viewAs.start(person, { ...(to ? { to } : {}), ...(back ? { back } : {}) })
  }
  if (kind === 'menu') {
    return (
      <>
        <button type="button" role="menuitem" className={itemClass} disabled={viewAs.busy} aria-busy={viewAs.busy || undefined} onClick={go}>
          {label || viewAsLabel(person)}
        </button>
        {viewAs.error && <span className="ad-error" role="alert">{viewAs.error}</span>}
      </>
    )
  }
  return (
    <span className="ad-viewas">
      <button type="button" className={`ad-btn ad-btn--line${size === 'md' ? '' : ` ad-btn--${size}`}`} disabled={viewAs.busy}
        aria-busy={viewAs.busy || undefined} onClick={go}>
        <Icon name="eye" size={16} />{label || viewAsLabel(person)}
      </button>
      {viewAs.error && <span className="ad-error" role="alert">{viewAs.error}</span>}
    </span>
  )
}
